import { createFileRoute } from '@tanstack/react-router'
import { ApiDocsPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/api-docs')({
  head: () => staticRouteHead('apiDocs', 'en'),
  component: ApiDocsPage,
})
